import React, { useState, useEffect } from "react";
import Pagination from "../../../../../../../components/Pagination";
import { AffiliateWithdrawalsData } from "../../../network/api/AffiliateWithdrawalsData";
import Toast from "../../../../../../../components/Toast";

export default function Withdrawals({ userId, reload, setActiveTab }) {
    const [isLoading, setIsLoading] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);

    const [toastConfig, setToastConfig] = useState({
        visible: false,
        message: "",
        type: "primary",
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        owner: userId,
        limit: 10
    });

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };

    useEffect(() => {
        const fetchWithdrawals = async () => {
            setIsLoading(true);
            const response = await AffiliateWithdrawalsData({ pageFilters });
            if (response.status === "success") {
                setWithdrawals(response.data.data);
                setPageProps((prev) => ({
                    page: response.data.page,
                    totalPages: response.data.total_pages,
                    totalEntries: response.data.total_records,
                    entryLimit: response.data.limit,
                    visiblePages: response.data.visible_pages,
                }));
            } else {
                setToastConfig({
                    visible: true,
                    message: response.message,
                    type: "danger",
                });
            }
            setIsLoading(false);
        };

        fetchWithdrawals();
    }, [userId, reload, pageFilters]);
    return (
        <div className="row" key={`withdrawals-${userId}hjjk`}>
            {isLoading && (
                <div className="text-center my-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}

            <div className="col-lg-12">
                <Toast message={toastConfig.message}
                    type={toastConfig.type}
                    visible={toastConfig.visible}
                    setVisible={(visible) => setToastConfig({ ...toastConfig, visible })} />
                <div className="card custom-card">
                    <div className="card-header">
                        <h4 className="card-title">Withdrawals</h4>

                        <div className="card-options">
                            <button className="btn btn-primary btn-sm" onClick={() => setActiveTab("earnings")}>
                                <i className="fa fa-sync me-2"></i>
                                Earnings
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer ">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Amount</th>
                                        <th>Method</th>
                                        <th>Status</th>
                                        <th>Reference</th>
                                        <th>Reason</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {withdrawals?.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="text-center py-5">
                                                <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                                                    <i className="fa fa-folder-open fa-3x mb-3"></i>
                                                    <p className="mb-0">No Withdrawals found</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        withdrawals?.map((withdrawal) => (
                                            <tr key={`withdrawal-${withdrawal.id}`}>
                                                <td>{withdrawal.id}</td>
                                                <td>${parseFloat(withdrawal.amount).toFixed(2)}</td>
                                                <td>{withdrawal.method}</td>
                                                <td>
                                                    <span className={`badge ${withdrawal.status === "approved" ? "bg-success" : withdrawal.status === "pending" ? "bg-warning" : "bg-danger"}`}>
                                                        {withdrawal.status}
                                                    </span>
                                                </td>
                                                <td>{withdrawal.transaction_reference || "-"}</td>
                                                <td className="text-wrap text-break" style={{ maxWidth: "300px" }}>
                                                    {withdrawal.reason || "-"}
                                                </td>
                                                <td>{new Date(withdrawal.created_at).toLocaleString()}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            <Pagination
                                pageProps={pageProps}
                                onPageChange={handlePageChange} />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}